import styled, { css } from 'styled-components';

import { ColumnsLayoutProps } from './ColumnsLayout';

import { Typography } from '@speeki/global-ui-components';

import { Container } from '@components/ions/layouts';

import { maxWidth } from '@utils/helpers';

export const ColumnsTemplateContent = styled(Container)<
    Required<Pick<ColumnsLayoutProps, 'contentAlign' | 'contentPadding'>>
>`
    ${({ contentAlign, contentPadding }) => css`
        align-content: ${contentAlign};
        display: grid;
        gap: 40px 32px;
        grid-template-columns: 1fr 1fr;
        justify-content: center;
        padding-top: ${contentPadding.top}px;
        padding-bottom: ${contentPadding.bottom}px;

        ${maxWidth('md')} {
            gap: 16px;
            grid-template-columns: 1fr;
        }

        ${maxWidth('sm')} {
            align-content: flex-start;
            padding-top: 16px;
        }
    `}
`;

export const ColumnsTemplateColumn = styled.div<
    Pick<ColumnsLayoutProps, 'columnsAlign'>
>`
    ${({ columnsAlign }) => css`
        align-items: ${columnsAlign};
        display: grid;
        width: 100%;

        & + & {
            ${maxWidth('md')} {
                margin-top: 8px;
            }
        }
    `}
`;

export const ColumnsTemplateHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    grid-column: 1 / 3;

    ${maxWidth('md')} {
        grid-column: auto;
    }
`;

export const ColumnsTemplateTitle = styled(Typography.TextH1_36_52)`
    ${({ theme: { fontSize, fontWeight } }) => css`
        text-align: center;

        ${maxWidth('sm')} {
            font-size: ${fontSize[24]}px;
            line-height: 32px;
            font-weight: ${fontWeight.normal};
        }
    `}
`;
